import * as types from './action-types';

const initialState = {
  businessEntities: []
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case 'GET_BUSINESS_ENTITIES_SUCESS':
      console.log(action.businessEntitiesDataSource);
      return {
        ...state,
        businessEntitiesDataSource: action.businessEntitiesDataSource
      };
      // return state;
      break;
    case 'SET_DEFAULT_BUSINESS_ENTITY':
      return { ...state, businessEntity: action.data };
    case 'SET_COUNTRY':
      return Object.assign({}, state, {
        country: action.data
      });

    case 'SET_COSTCENTER':
      return Object.assign({}, state, {
        costcenter: action.data
      });
    case 'SET_BUSINESSENTITY':
      return Object.assign({}, state, {
        businessEntity: action.data
      });
    case 'SET_WORKFLOW_APPROVAL_LIST':
      //  console.log('SET_WORKFLOW_APPROVAL_LIST');
      // console.log(action.data);
      return { ...state, workflow: action.data };
    case 'SET_SELECTED_APPROVER_DETAIL':
      return { ...state, selectedApproverDetail: action.data };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/features/corporate-quote-workflow-setup/reducer.js